
import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import vegetableImage from "../Assest/images/vegetableImage.avif";
import dairyImage from "../Assest/images/dairyImage.webp";
import fruitImage from "../Assest/images/fruitImage.avif";
import bakeryImage from "../Assest/images/bakeryImage.avif";
import beverageImage from "../Assest/images/beverageImage.jpg";
import pantryImage from "../Assest/images/pantryImage.jpg";
import Logo from "../Assest/images/logo.png";
import Loader from "../components/Loader";
import axios from "axios";

const Branding = ({ data }) => {

  const [flippedCard, setFlippedCard] = useState(null);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const categories = [
    {
      id: 1,
      title: "Fresh Vegetables",
      subtitle: "Farm Fresh",
      description: "Get up to 30% Off on daily picks",
      buttonText: "Shop Now",
      bgColor: "bg-green-100",
      size: "lg:col-span-2 col-span-full row-span-1",
      imageUrl: vegetableImage, // Yahan apni vegetable image import karein
      flipped: false,
    },
    {
      id: 2,
      title: "Dairy & Eggs",
      subtitle: "Daily Essentials",
      description: "Fresh milk, cheese & eggs",
      buttonText: "Shop Now",
      bgColor: "bg-blue-50",
      size: "lg:col-span-1 md:col-span-2 col-span-full row-span-1",
      imageUrl: dairyImage, // Yahan apni dairy image import karein
      flipped: false,
    },
    {
      id: 3,
      title: "Fresh Fruits",
      subtitle: "Seasonal Specials",
      description: "Organic & hand-picked",
      buttonText: "Shop Now",
      bgColor: "bg-orange-100",
      size: "lg:col-span-1 md:col-span-2 col-span-full row-span-1",
      imageUrl: fruitImage, // Yahan apni fruit image import karein
      flipped: false,
    },
    {
      id: 4,
      title: "Bakery",
      subtitle: "Freshly Baked",
      description: "Bread, cookies & cakes",
      buttonText: "Shop Now",
      bgColor: "bg-yellow-50",
      size: "lg:col-span-1 md:col-span-2 col-span-full row-span-1",
      imageUrl: bakeryImage, // Yahan apni bakery image import karein
      flipped: false,
    },
    {
      id: 5,
      title: "Beverages",
      subtitle: "Cold & Hot",
      description: "Juices, tea & coffee",
      buttonText: "Shop Now",
      bgColor: "bg-teal-50",
      size: "lg:col-span-1 md:col-span-2 col-span-full row-span-1",
      imageUrl: beverageImage, // Yahan apni beverage image import karein
      flipped: false,
    },
    {
      id: 6,
      title: "Pantry Staples",
      subtitle: "Kitchen Needs",
      description: "Best deals on rice, oil & flour",
      buttonText: "Shop Now",
      bgColor: "bg-stone-100",
      size: "lg:col-span-2 col-span-full row-span-1",
      imageUrl: pantryImage, // Yahan apni pantry image import karein
      flipped: false,
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      const nextCard =
        flippedCard === null ? 0 : (flippedCard + 1) % categories.length;
      setFlippedCard(nextCard);
    }, 3000);

    return () => clearInterval(interval);
  }, [flippedCard, categories.length]);

  const handleMouseEnter = (index) => {
    setFlippedCard(index);
  };

  const handleMouseLeave = () => {
    // Optional: You can comment this out if you want the card to stay flipped
    // when the mouse leaves
  };
  const handleShopNow = useCallback(
    async (companyId) => {
      try {
        setIsLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_API_URI}/products/company/${companyId}`
        );
        if (response.status === 200) {
          localStorage.setItem("apiProducts", JSON.stringify(response.data));

          navigate(`/product?id=${companyId}`, {
            state: {
              apiData: response.data,
              companyId: companyId,
            },
          });
        }
      } catch (error) {
        console.error("Error fetching company ", error);
      } finally {
        setIsLoading(false);
      }
    },
    [navigate]
  );

  return (
    <>
      <div className="max-w-6xl mx-auto p-4">
        {isLoading && <Loader Logo={Logo} />}
        <div className="grid grid-cols-4 gap-4">
          {categories.map((category, index) => (
            <div
              key={category.id}
              className={`${category.size} relative overflow-hidden rounded-lg shadow-lg h-64 sm:h-72 md:h-80 perspective-1000`}
              onMouseEnter={() => handleMouseEnter(index)}
              onMouseLeave={handleMouseLeave}
            >
              {/* Flip card container */}
              <div
                className={`relative w-full h-full transition-transform duration-700 transform-style-3d ${flippedCard === index ? "rotate-y-180" : ""
                  }`}
              >
                {/* Front of card */}
                <div className="absolute w-full h-full backface-hidden">
                  <div className="relative h-full w-full overflow-hidden">
                    {/* Background image covering the entire card */}
                    <img
                      src={category.imageUrl}
                      alt={category.title}
                      className="absolute h-full w-full object-cover"
                    />

                    {/* Overlay to make text more readable */}
                    <div className="absolute inset-0 bg-black bg-opacity-20"></div>

                    {/* Content */}
                    <div className="absolute inset-0 flex flex-col justify-center p-6 text-white">
                      <span className="inline-block w-[100px] px-2 py-1 bg-[#ea580c] text-white text-xs font-semibold rounded mb-2">
                        {category.subtitle}
                      </span>
                      <h2 className="text-2xl md:text-3xl font-bold mb-2 drop-shadow-md">
                        {category.title}
                      </h2>
                      {category.description && (
                        <p className="text-sm md:text-base mb-4 drop-shadow-md">
                          {category.description}
                        </p>
                      )}
                      <button
                        onClick={() => handleShopNow(category.companyId)}
                        className="mt-2 inline-block w-max bg-white bg-opacity-90 text-gray-800 px-4 py-2 rounded-full font-medium hover:bg-opacity-100 transition duration-300 transform hover:scale-105"
                      >
                        {category.buttonText} →
                      </button>
                    </div>
                  </div>
                </div>

                {/* Back of card */}
                <div className="absolute w-full h-full backface-hidden rotate-y-180">
                  <div className="h-full w-full relative overflow-hidden">
                    {/* Background image with blur effect */}
                    <img
                      src={category.imageUrl}
                      alt={category.title}
                      className="absolute h-full w-full object-cover filter blur-sm scale-110"
                    />

                    {/* Colored overlay */}
                    <div className="absolute inset-0 bg-black bg-opacity-40"></div>

                    {/* Content */}
                    <div className="relative h-full w-full flex flex-col justify-center items-center text-center p-6 text-white">
                      <h3 className="text-xl md:text-2xl font-bold mb-2">
                        {category.title}
                      </h3>
                      <p className="text-sm text-gray-200 mb-4">
                        {index === 0
                          ? "Farm Fresh"
                          : index === 1
                            ? "Daily Essentials"
                            : index === 2
                              ? "Seasonal Specials"
                              : index === 3
                                ? "Freshly Baked"
                                : index === 4
                                  ? "Cold & Hot"
                                  : "Kitchen Needs"}
                      </p>
                      <p className="mb-4 text-md max-w-xs">
                        {index === 0
                          ? "Get up to 30% Off on daily picks, straight from the local farms to your kitchen."
                          : index === 1
                            ? "Fresh milk, cheese, organic eggs, and buttery spreads delivered fresh every morning."
                            : index === 2
                              ? "Discover the sweetness of organic, hand-picked, and nutrient-rich seasonal fruits."
                              : index === 3
                                ? "Indulge in freshly baked artisan bread, crispy cookies, and mouth-watering cakes."
                                : index === 4
                                  ? "Revitalize your senses with refreshing juices, premium tea blends, and rich coffee."
                                  : "Best deals on monthly kitchen essentials like premium rice, oil, spices, and flour."}
                      </p>
                      <button
                        onClick={() => handleShopNow(category.companyId)}
                        className="bg-white text-gray-800 px-6 py-2 rounded-full font-medium hover:bg-gray-100 transition-all duration-300 transform hover:scale-105"
                      >
                        {category.buttonText}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <style jsx global>{`
        .perspective-1000 {
          perspective: 1000px;
        }

        .transform-style-3d {
          transform-style: preserve-3d;
        }

        .backface-hidden {
          backface-visibility: hidden;
        }

        .rotate-y-180 {
          transform: rotateY(180deg);
        }
      `}</style>
    </>
  );
};

export default Branding;
